export const WORKBENCH_ENTRY_SOURCE_WEB_SEARCH = "web_search" as const;

export type WorkbenchEntrySource = typeof WORKBENCH_ENTRY_SOURCE_WEB_SEARCH;

export interface Workbench360LocationState {
  amendment360?: boolean;
  workbenchEntrySource?: WorkbenchEntrySource;
  activeWorkbenchTab?: "webSearch";
}

export function isWebSearchWorkbenchEntry(
  state: unknown
): state is Workbench360LocationState & {
  workbenchEntrySource: typeof WORKBENCH_ENTRY_SOURCE_WEB_SEARCH;
} {
  if (!state || typeof state !== "object") return false;
  return (
    (state as Workbench360LocationState).workbenchEntrySource ===
    WORKBENCH_ENTRY_SOURCE_WEB_SEARCH
  );
}

/** State keys safe to forward between workbench ↔ web-results. */
export function pickWorkbenchNavigationState(
  state: unknown
): Pick<
  Workbench360LocationState,
  "workbenchEntrySource" | "amendment360" | "activeWorkbenchTab"
> {
  if (!state || typeof state !== "object") return {};
  const s = state as Workbench360LocationState;
  return {
    ...(s.workbenchEntrySource === WORKBENCH_ENTRY_SOURCE_WEB_SEARCH
      ? { workbenchEntrySource: WORKBENCH_ENTRY_SOURCE_WEB_SEARCH }
      : {}),
    ...(s.amendment360 === true ? { amendment360: true } : {}),
    ...(s.activeWorkbenchTab === "webSearch"
      ? { activeWorkbenchTab: "webSearch" as const }
      : {}),
  };
}

export function buildWebSearchWorkbenchNavigationState(
  state: unknown
): Pick<
  Workbench360LocationState,
  "workbenchEntrySource" | "amendment360" | "activeWorkbenchTab"
> {
  return {
    ...pickWorkbenchNavigationState(state),
    workbenchEntrySource: WORKBENCH_ENTRY_SOURCE_WEB_SEARCH,
    activeWorkbenchTab: "webSearch",
  };
}

export function shouldOpenWebSearchWorkbenchTab(state: unknown) {
  if (!state || typeof state !== "object") return false;
  return (
    (state as Workbench360LocationState).activeWorkbenchTab === "webSearch"
  );
}
